export default [
    'updateCurrentLocation',
    'updateOrigin',
    'setResults',
    'addToResults',
    'clearResults',
    'clearSearchQuery',
    'setLoading',
    'setError',
    'setSearchQueryResults',
    'setCurrentJourney',
    'initFormValues',
    'setDefaultError',
    'setDefaultSuccess',
    'logoutUser',
    'setUserInfo',
    'getUserLogged',
    'updateUserAccount',
    'setUserToken',
    'userSavedJourneys',
    'userRecentJourneys',
    'recentJourneysMeta',
    'savedJourneysMeta',
    'clearErrors',
    'campaigns',
    'campaignImpressions',
    'addResultQueryStages',
    'setResultSort',
    'handleMultipleFilterChange',
    'setMultipleResultStages',
]
